function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-35"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 370.6,
    cy: 215.06,
    r: 55.94,
    transform: "translate(4.69 438.01) rotate(-61.48)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-35"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 291.86,
    cy: 95.61,
    r: 27.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.72,453.25c-48.12,9-100.72-7.93-139.17-35.75-29.86-21.6-49.26-52.39-60.52-88.2-10.69-34-14.44-69.07-40.61-94.29-20.56-19.82-43.26-41.21-36.86-74.92,3.2-16.84,10.4-41.49,21.52-55C113.37,62.13,160.3,52.9,210.84,65c43.3,10.4,86.85,35.74,109.44,73.58a145.63,145.63,0,0,1,11.09,22.68C339.32,182,338,221.18,353,238.13c17.65,20,53,17,73.88,32.11,21.58,15.64,31.32,58.32,20.52,90.72C428.86,416.47,391.71,442.44,333.72,453.25Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.72,453.25c-48.12,9-100.72-7.93-139.17-35.75-29.86-21.6-49.26-52.39-60.52-88.2-10.69-34-14.44-69.07-40.61-94.29-20.56-19.82-43.26-41.21-36.86-74.92,3.2-16.84,10.4-41.49,21.52-55C113.37,62.13,160.3,52.9,210.84,65c43.3,10.4,86.85,35.74,109.44,73.58a145.63,145.63,0,0,1,11.09,22.68C339.32,182,338,221.18,353,238.13c17.65,20,53,17,73.88,32.11,21.58,15.64,31.32,58.32,20.52,90.72C428.86,416.47,391.71,442.44,333.72,453.25Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451,194.48C437.08,141.05,398.3,92.76,347.85,69.39c-28.66-13.27-65-19.25-94.66-8.65-29.2,10.45-45.9,31.92-57.89,59.9-13.19,30.79-24.72,58.88-53.84,77.52-32.56,20.83-67.83,28-85.11,67C43.87,293.42,45.41,327.94,60.42,356c9.34,17.45,24.39,32.8,43.18,38.53,17.32,5.29,35.79,2,52.68-3.41,24.24-7.73,51.64-22.77,78.33-16.32,44.37,10.73,80.88,40,148.66,6.62,52.44-25.85,78.71-78.08,75.56-135.32A263.46,263.46,0,0,0,451,194.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,286.83a4.29,4.29,0,1,0,4.4,4.18A4.29,4.29,0,0,0,78,286.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.41,133.28a4.29,4.29,0,1,0,4.4,4.18A4.29,4.29,0,0,0,314.41,133.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.37,343.47a4.29,4.29,0,1,0,4.39,4.18A4.28,4.28,0,0,0,330.37,343.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.88,256.57a4.29,4.29,0,1,0,4.39,4.18A4.29,4.29,0,0,0,431.88,256.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.62,359.72A4.29,4.29,0,1,0,266,363.9,4.28,4.28,0,0,0,261.62,359.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,351.77a4.29,4.29,0,1,0,4.4,4.18A4.28,4.28,0,0,0,390.14,351.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.18,81a4.29,4.29,0,1,0,4.4,4.18A4.29,4.29,0,0,0,245.18,81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.73,241c-4.68-3.38-9.74,1.94-6.13,6.44C242.28,250.77,247.34,245.46,243.73,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.04,
    cy: 253.27,
    r: 2.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,260a2.22,2.22,0,0,0-3.06,3.22A2.22,2.22,0,0,0,201.16,260Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.17,177.08c-4.68-3.38-9.73,1.94-6.13,6.44C218.72,186.9,223.78,181.58,220.17,177.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6,196.16a2.22,2.22,0,0,0-3.06,3.22A2.22,2.22,0,0,0,177.6,196.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.5,299.5a2.15,2.15,0,1,0,2.2,2.09A2.15,2.15,0,0,0,286.5,299.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.45,235.21a2.15,2.15,0,1,0,2.19,2.09A2.15,2.15,0,0,0,312.45,235.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.42,148.74a2.15,2.15,0,1,0,2.19,2.09A2.15,2.15,0,0,0,225.42,148.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.09,191.12a2.15,2.15,0,1,0,2.2,2.09A2.15,2.15,0,0,0,275.09,191.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.91,317a2.15,2.15,0,1,0,2.2,2.09A2.14,2.14,0,0,0,100.91,317Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,360.47a2.15,2.15,0,1,0,2.19,2.09A2.14,2.14,0,0,0,107,360.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.34,324.48a2.15,2.15,0,1,0-2.09,2.2A2.15,2.15,0,0,0,346.34,324.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.67,366.66a2.14,2.14,0,1,0,2.2,2.09A2.14,2.14,0,0,0,346.67,366.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,302.55a2.15,2.15,0,1,0,2.2,2.09A2.15,2.15,0,0,0,423,302.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.78,
    cy: 141.68,
    r: 2.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.63,
    cy: 269.24,
    r: 6.92,
    transform: "translate(2.76 541.4) rotate(-86.8)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.5,
    cy: 109.89,
    r: 5.56,
    transform: "translate(-2.63 8.61) rotate(-1.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.56,338.29c-.49,4.47-1,5-5.41,5.69,4.47.5,5,1,5.69,5.42.5-4.48,1-5,5.42-5.7C71.79,343.21,71.28,342.73,70.56,338.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.21,360c-.4,3.64-.79,4.05-4.4,4.63,3.63.4,4,.79,4.62,4.4.41-3.63.8-4,4.41-4.62C377.2,364,376.79,363.64,376.21,360Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,259.47c-.4,3.63-.79,4-4.4,4.63,3.63.4,4,.79,4.63,4.4.4-3.64.79-4.05,4.4-4.63C275.09,263.47,274.68,263.08,274.1,259.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.85,246.93c-.41,3.63-.8,4-4.41,4.63,3.64.4,4.05.79,4.63,4.4.4-3.64.79-4.05,4.4-4.63C441.84,250.93,441.43,250.54,440.85,246.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.23,
    cy: 248.35,
    r: 4.52,
    transform: "translate(-6.15 2.97) rotate(-1.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.11,107.86c-.41,3.64-.8,4-4.41,4.63,3.64.4,4.05.79,4.63,4.4.4-3.63.79-4,4.4-4.63C216.1,111.86,215.69,111.47,215.11,107.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-5--inject-35"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 205.42,
    cy: 332.7,
    r: 13.91,
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.88,322.49a10.57,10.57,0,0,0-3.23-1.94,13.66,13.66,0,0,1,3.55-1.39,33,33,0,0,1,3.74,2.77c5.09,4.4,3.72,4,11,6.52a11.5,11.5,0,0,1,1.94.87,14.37,14.37,0,0,1,.42,3,13.92,13.92,0,0,1-.86,5.14c-2.61-.72-6.07-1.91-7.7-3.46C208,331.39,207.43,327.33,201.88,322.49Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.76,342a13.75,13.75,0,0,1-3.57,2.86c-2.63-1.74-3.88-3.63-7.62-5.22-3.27-1.39-8.63-1.58-12-1.54a13.86,13.86,0,0,1-1.09-5c0-.24,0-.47,0-.71a40,40,0,0,1,11.56,2.35C208.4,336.65,211.05,340.31,215.76,342Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.57,327.93c-2.43,1.29-6.23.74-9.2,0a13.78,13.78,0,0,1,2.24-3.95C198.54,324.59,204.93,326.14,201.57,327.93Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.63,320c16,.79,29.27,5.2,29.4,10.5.15,6.22-16,11.66-36.15,12.16s-36.56-4.13-36.71-10.34c-.14-5.62,13.07-10.61,30.47-11.88",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.79,320.57c9.86,1.15,16.92,4.48,17,8.58.13,5.33-11.51,9.94-26,10.3s-26.36-3.67-26.49-9c-.12-4.45,8-8.4,19.1-9.79",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.73,335a2.39,2.39,0,1,0-2.33,2.45A2.38,2.38,0,0,0,240.73,335Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.09,330a2.39,2.39,0,1,0-2.32,2.45A2.38,2.38,0,0,0,181.09,330Z",
    style: {
      fill: "#FFC100"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-4--inject-35"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 332.22,
    cy: 354.98,
    r: 21.49,
    transform: "translate(-47.94 658.06) rotate(-85.46)",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.76,343.18l10.78,14.36a21.32,21.32,0,0,0-.69-8.5Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.73,336.85l25.63,34.31a21.3,21.3,0,0,0,4.9-6.27l-21.55-31.23A21.58,21.58,0,0,0,320.73,336.85Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,376.44l-11.14-15.12,6,14.44A20.8,20.8,0,0,0,332,376.44Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.66,374.72l-25.42-32.9c-.23.3-.44.62-.66.94l18.59,33.69A21.61,21.61,0,0,0,340.66,374.72Z",
    style: {
      fill: "#FFC100"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-3--inject-35"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 370.6,
    cy: 215.06,
    r: 55.94,
    transform: "translate(4.69 438.01) rotate(-61.48)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-35)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.34,191.52l-70.49-8.64,59.72-6.95c-.81-.84-1.66-1.64-2.53-2.43l-77.59,2.61a55.22,55.22,0,0,0-8,10.47l19.21,2.47-22.36,3.66s0,0,0,0l27.54,5.2-31.64,9.46c-.11.8-.2,1.59-.28,2.39l76-3.34-49.41,11.61,26.59,3.31-24.47,6.94L425.64,225a55.59,55.59,0,0,0-.56-22.65l-21.46-3.24,20.18-1.3A57.42,57.42,0,0,0,421.34,191.52Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.33,236.33,355.56,238l35.53,4.08-59.5,13.08a55.9,55.9,0,0,0,77.15.82l-22.84,3.56,29.24-10.62A55.44,55.44,0,0,0,422.33,236.33Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.82,166l37.6-.79-11.56-3.08,9.77-2.23A55.72,55.72,0,0,0,343.82,166Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.55,238,319,236.6a56.4,56.4,0,0,0,9.15,14.87Z",
    style: {
      fill: "#FFC100"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 370.6,
    cy: 215.06,
    r: 55.94,
    transform: "translate(4.69 438.01) rotate(-61.48)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.76,127.26c-9.47-2.53-21.88,10.6-32.94,32.55a57.73,57.73,0,0,1,6-.61c8.23-16.43,16.64-26.06,22.74-24.44,10.83,2.89,10.32,40.13-1.16,83.17s-29.55,75.61-40.38,72.72c-5.58-1.49-8.14-12.11-7.75-27.94a56.33,56.33,0,0,1-4.94-3.42c-.57,22.07,3.71,37.58,12.56,39.94,15,4,37.41-31.26,50.07-78.75S409.76,131.25,394.76,127.26Z",
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-2--inject-35"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 291.86,
    cy: 95.61,
    r: 27.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-35)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.33,68.88c9,7,25.59,24.58,15.3,53.41a27.78,27.78,0,0,0-8.46-54.44A27.51,27.51,0,0,0,284.33,68.88Z",
    style: {
      fill: "#FFC100"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 291.86,
    cy: 95.61,
    r: 27.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.32,
    cy: 80.57,
    r: 4.17,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.95,
    cy: 76.47,
    r: 2.22,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.51,
    cy: 92.44,
    r: 3.61,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.51,
    cy: 94.96,
    r: 2.78,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.04,
    cy: 111.65,
    r: 5,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.1,
    cy: 93.72,
    r: 1.94,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.58,
    cy: 109,
    r: 3.06,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-1--inject-35"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 127.8,
    cy: 152.21,
    r: 21.49,
    style: {
      fill: "#FFC100",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.47,136.19a16.77,16.77,0,0,1,4.84-3.24,21.25,21.25,0,0,0-5.59-1.86,49.58,49.58,0,0,0-5.55,4.56c-7.51,7.18-5.43,6.43-16.51,10.9a18.56,18.56,0,0,0-2.92,1.49,21.12,21.12,0,0,0,1.3,12.58c4-1.32,9.22-3.42,11.61-5.93C123.74,150.39,124.28,144.09,132.47,136.19Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56,167.33a21.62,21.62,0,0,0,5.73,4.14c3.93-2.89,5.71-5.91,11.35-8.64,5-2.4,13.2-3.11,18.35-3.3a21.33,21.33,0,0,0,1.29-7.85c0-.37-.05-.73-.08-1.1a61.93,61.93,0,0,0-17.66,4.51C123.5,158.54,119.71,164.39,112.56,167.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38,144.56c3.84,1.8,9.66.67,14.19-.74a21.35,21.35,0,0,0-3.76-5.92C137.79,139.19,128.05,142.06,133.38,144.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Meteor--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.83,205.55c-5-1.78-10.37-2.3-14.94.58-3.87,2.44-5.68,7.89-10.53,8.59-5.77.83-6.6-.36-10.17,2.12a6.91,6.91,0,0,0-3,6.32s3.85-5.13,8.89-4.22a2.82,2.82,0,0,1,1.73.73c-3.75,1.19-8.06.84-10.62,3.49a47.72,47.72,0,0,0-6.49,9.45c-1.55,2.84-5,1.38-9.15,4.59s-6.23,4.5-7.6,8.63-3,6.32-6.67,8.16a37.16,37.16,0,0,1-7.15,2.67s5.87,2.1,9.53.26,5-3.67,8.05-7.71,13.56-3.59,13.56-3.59-6.87,2.3-10.44,7.07-4,8.43-10.06,9.63c-5.13,1-8.67-.06-11.31,1.82a12.23,12.23,0,0,0-6.57,4.36c-3.85,5.08-4.7,6-10.18,7.11s-10.55,6.43-13.36,11.83-3.1,8.16-10.27,11.07-10.94,4-14.63,8.58a53.76,53.76,0,0,0-5,7s8.27-8.28,18.56-10.22,18.56-10.21,20.17-15.42S142,285.51,149,281.4a22.73,22.73,0,0,0,2.81-2,5.14,5.14,0,0,0,1.2-1.07c2.71-2.57,4.32-5.22,6.45-6.87a14.25,14.25,0,0,1,4.55-.72c10.44-.2,18.14-1.31,21.25-7s5.3-8.62,10.34-7.71,8.79-.28,10.72-.56,3.11-1.11-1.37,4.12-10,3.41-11.63,5.61l-4.39,5.87s3.84-5.14,9.52-4.32,14.3-.75,16.49-3.69,6.5-7.15,9.61-8.26,9.07-2.94,10.45-4.79a20.54,20.54,0,0,1,2.68-3.22c.11,4.6-3.13,9.5-6.59,12.39a30.16,30.16,0,0,0,11.74-9,29.31,29.31,0,0,0,3.4-5.39C253.61,229.68,246.86,211.27,230.83,205.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,210.69s-6.78-2.74-12.14-1.85-7.19,4.76-10.55,9.44-7,5.14-11.08,7.05a12.62,12.62,0,0,0-6.3,6c-.27.87.94-1,3.41-1.8a20.75,20.75,0,0,1,6.23-.61,12.94,12.94,0,0,1-6.88,5.81c-5,1.93-8.49,2.78-10.19,4.16a11.89,11.89,0,0,0-2.7,3.61c-.56.78,2.43-2.74,6.49-1.49s10,.56,10,.56-7.75,1.41-10.85,4.26-4.28,6.62-5.65,10-4.35,2.78-6.61,4.94a18.39,18.39,0,0,0-3.63,5.55,30.53,30.53,0,0,1,9.3-5.38c5.33-1.84,4.53-3.36,7.89-8s8.53-5,12.59-3.73,11.41-.91,11.41-.91-1.28,3.1-3.29,3.43.62,2.1,3.57.78,3.76-3.92,6.95-2.93,3.59,1.75,6.53.44,7.47-5.63,11.38-7,7.52-12,5-19.4S233,210.69,233,210.69Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38,213.76l-5.6-1.66a9,9,0,0,0-6.38.49l-6.08,2.91a12.13,12.13,0,0,0-6.49,7.85L205.56,232s3.77,10.26,7.53,12.5,14.76,1.31,19.52.29,9.25-6.24,9.61-10.55,1.54-9.71-1.31-13.55S232.38,213.76,232.38,213.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,223.8a3.18,3.18,0,1,1-.64-4.45A3.17,3.17,0,0,1,233.15,223.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,222.49a2.49,2.49,0,1,1-.5-3.48A2.48,2.48,0,0,1,221,222.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.41,233.33a2.35,2.35,0,1,1-.48-3.29A2.35,2.35,0,0,1,227.41,233.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.89,227.17a1.11,1.11,0,1,1-.23-1.55A1.11,1.11,0,0,1,237.89,227.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.83,232.79a1.8,1.8,0,1,1-.36-2.52A1.81,1.81,0,0,1,218.83,232.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.09,218a1.38,1.38,0,1,1-2.21-1.66,1.38,1.38,0,1,1,2.21,1.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0481425523757935px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace);
export default __webpack_public_path__ + "static/media/space.171ab69ad7ff7ae084df1f1b7e07ce40.svg";
export { ForwardRef as ReactComponent };